<template>
  <ion-page>
    <ion-header class="ion-no-border" color="primary">
      <ion-toolbar mode="md" class="custom-header">
        <ion-title v-if="!search"><strong>Datozen lanak</strong></ion-title>

        <ion-buttons slot="end">
          <ion-button @click="searchBox">
            <ion-icon
              v-if="!search"
              slot="icon-only"
              :icon="searchOutline"
            ></ion-icon>
            <ion-icon v-else slot="icon-only" :icon="closeOutline"></ion-icon>
          </ion-button>
        </ion-buttons>

        <ion-searchbar
          v-if="search"
          :value="searchTerm"
          @ionInput="searchTerm = $event.target.value"
          show-cancel-button="never"
          mode="md"
          placeholder="Lanak bilatu"
        >
        </ion-searchbar>
      </ion-toolbar>
    </ion-header>
    <ion-content color="tertiary">
      <ion-refresher slot="fixed" @ionRefresh="doRefresh($event)">
        <ion-refresher-content></ion-refresher-content>
      </ion-refresher>

      <errors
        v-if="!loading && items && !items.length"
        :options="{
          title: 'Adi!',
          message: 'Ez da lanik aurkitu.',
          image: true,
        }"
      />

      <ion-list
        v-if="!loading"
        class="ok-list"
        mode="ios"
      >
        <ion-item
          v-for="item in items"
          :key="item"
          color="transparent"
          lines="none"
          button
          :detail="false"
          class="ok-list-item"
          @click="_editJob(item.id)"
        >
          <ion-label>
            <strong>{{ item.client.name }}</strong>
            <ion-icon v-if="item.special_date" :icon="pin" />
            <p>
              {{ item.job_term.name }}
              <template v-if="!item.special_date">
                -
                <span v-if="item.is_default"
                  >({{ item.job_term.frecuency }} egunero)</span
                >
                <span v-else>({{ item.frecuency }} egunero)</span>
              </template>
            </p>
          </ion-label>

          <ion-badge
            class="soft-badge"
            :style="jobBadgeStyle(item)"
            v-if="item.difference <= 1"
            >{{ item.difference }} egun</ion-badge
          >
          <ion-badge
            class="soft-badge"
            :style="jobBadgeStyle(item)"
            v-else-if="item.difference > 1 && item.difference < 5"
            >{{ item.difference }} egun</ion-badge
          >
          <ion-badge
            class="soft-badge"
            :style="jobBadgeStyle(item)"
            v-else
            >{{ item.difference }} egun</ion-badge
          >
          <ion-icon
            slot="end"
            class="ok-list-chevron"
            :icon="chevronForwardOutline"
          ></ion-icon>
        </ion-item>
      </ion-list>

      <ion-list
        v-else
        style="padding-top: 0; padding-bottom: 0"
        mode="ios"
        lines="full"
        inset="false"
      >
        <ion-item
          v-for="item in 20"
          :key="item"
          color="transparent"
          lines="full"
        >
          <ion-label>
            <h3>
              <ion-skeleton-text
                animated
                style="width: 60%"
              ></ion-skeleton-text>
            </h3>
          </ion-label>

          <ion-skeleton-text animated style="width: 20%"></ion-skeleton-text>
        </ion-item>
      </ion-list>

      <ion-fab
        vertical="bottom"
        horizontal="end"
        slot="fixed"
        @click="router.push('job-terms')"
        mode="ios"
        color="dark"
      >
        <ion-fab-button>
          <ion-icon :icon="notificationsOutline"></ion-icon>
        </ion-fab-button>
      </ion-fab>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonItem,
  IonLabel,
  IonList,
  IonButtons,
  IonButton,
  IonBadge,
  IonRefresher,
  IonRefresherContent,
  IonSkeletonText,
  IonSearchbar,
  IonFab,
  IonFabButton,
  IonIcon,
  loadingController,
} from "@ionic/vue";

import { ref, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import axios from "axios";
import { safeControllerDismiss } from "@/utils/overlays";
import Errors from "@/components/Errors.vue";
import {
  arrowBackOutline,
  ellipsisHorizontal,
  personAddOutline,
  homeOutline,
  checkmarkCircle,
  notificationsOutline,
  warning,
  closeOutline,
  searchOutline,
  pin,
  chevronForwardOutline,
} from "ionicons/icons";
export default {
  name: "Jobs",
  components: {
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonPage,
    IonItem,
    IonLabel,
    IonList,
    IonButtons,
    IonButton,
    IonBadge,
    IonRefresher,
    IonRefresherContent,
    IonSkeletonText,
    IonSearchbar,
    IonFab,
    IonFabButton,
    IonIcon,
    Errors,
  },
  setup() {
    const loading = ref(true);
    const search = ref(false);
    const isDisabled = ref(false);
    //const perPage = ref(50);
    const store = useStore();
    const router = useRouter();
    const items = ref(null);
    const searchTerm = ref(null);

    const searchBox = () => {
      search.value = !search.value;
      if (!search.value) {
        searchTerm.value = "";
      }
    };

    const doRefresh = (ev) => {
      store.dispatch("_jobsReload").then(() => {
        ev.target.complete();
      });
    };
    const getJobs = computed(() => store.state.getJobs);

    onMounted(() => {
      items.value = getJobs.value;
      loading.value = false;
    });

    watch(
      getJobs,
      (value) => {
        items.value = [];
        items.value = value;
        loading.value = false;
      },
      {
        deep: true,
      }
    );

    // searchbar
    watch(searchTerm, (value) => {
      if (value.length > 0 && value.length < 4) return;
      let search = value.toLowerCase();
      let array = items.value.filter((find) => {
        return find.job_term.name.toLowerCase().includes(search);
      });
      items.value = array;

      if (value.length == 0) {
        store.dispatch("_jobsReload");
      }
    });

    const presentLoading = async () => {
      const loadingPage = await loadingController.create({
        mode: "ios",
        translucent: true,
        backdropDismiss: false,
      });
      await loadingPage.present();
    };

    const _loadJobArchive = async (jobId) => {
      return axios.get(`job/${jobId}`).then((res) => {
        const result = res.data.result?.[0] || null;

        if (result?.jobs_archive) {
          result.jobs_archive.sort((a, b) => {
            return new Date(b.work_date) - new Date(a.work_date);
          });
        }

        return result;
      });
    };

    const _editJob = async (job) => {
      await presentLoading();

      try {
        const archive = await _loadJobArchive(job);
        await router.push({
          path: `/jobs-archive/${job}`,
          state: {
            archive,
          },
        });
      } catch (error) {
        await safeControllerDismiss(loadingController);
        throw error;
      }
    };

    const jobBadgeStyle = (item) => {
      if (item.difference <= 1) {
        return {
          "--background": "#ff3b30",
          "--color": "#ffffff",
          background: "#ff3b30",
          color: "#ffffff",
          borderColor: "rgba(255, 59, 48, 0.28)",
        };
      }

      if (item.difference > 1 && item.difference < 5) {
        return {
          "--background": "#ffd60a",
          "--color": "#3a2a00",
          background: "#ffd60a",
          color: "#3a2a00",
          borderColor: "rgba(255, 214, 10, 0.32)",
        };
      }

      return {
        "--background": "#30d158",
        "--color": "#ffffff",
        background: "#30d158",
        color: "#ffffff",
        borderColor: "rgba(48, 209, 88, 0.3)",
      };
    };

    return {
      router,
      isDisabled,
      items,
      doRefresh,
      arrowBackOutline,
      ellipsisHorizontal,
      personAddOutline,
      homeOutline,
      checkmarkCircle,
      warning,
      _editJob,
      loading,
      closeOutline,
      notificationsOutline,
      search,
      searchTerm,
      IonSearchbar,
      searchOutline,
      searchBox,
      pin,
      chevronForwardOutline,
      jobBadgeStyle,
    };
  },
};
</script>

<style lang="scss">
@import "@/theme/theme.scss";
.toolbar-title-default {
  box-shadow: none !important;
}

.header-gradient {
  background-image: linear-gradient(45deg, red, black);
}

.soft-badge {
  --background: #f2f5f1;
  --color: rgba(22, 37, 29, 0.72);
  background: var(--background) !important;
  color: var(--color) !important;
  padding: 5px 8px;
  border: 1px solid rgba(22, 37, 29, 0.08);
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0;
}
</style>
